// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:15:48

export default {
  "id": "sponge-challenge",
  "slug": "sponge-challenge",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/47343e009bbf45fe9ba79bad81905853-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/47343e009bbf45fe9ba79bad81905853/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Sponge Challenge",
      "description": "In Sponge Challenge, you command a bouncy, yellow sponge through a captivating 2D puzzle platform adventure. Your mission is to guide the flexible sponge in collecting precious purple diamonds while maneuvering through levels packed with obstacles and devious traps. Each stage presents a unique puzzle that requires you to leverage the sponges sticky abilities to climb walls, jump between surfaces, and discover the perfect path to the magical portal that leads to subsequent levels.",
      "instructions": "Sponge Challenge employs simple yet engaging controls. Tap the screen to make your sponge jump. Utilize walls and platforms strategically to alter your direction mid-air, allowing you to navigate through each level’s obstacles and traps effectively.",
      "genres": [
        "Agility",
        "Casual"
      ],
      "tags": [
        "cube",
        "diamonds",
        "physics",
        "platformer",
        "run"
      ]
    },
    "zh-CN": {
      "title": "海绵挑战",
      "description": "在海绵挑战中，你将操控一个弹跳的黄色海绵，穿越迷人的2D解谜平台冒险。你的任务是引导这个灵活的海绵收集珍贵的紫色钻石，同时在充满障碍和狡猾陷阱的关卡中穿梭。每个阶段都呈现一个独特的谜题，需要你利用海绵的粘性能力攀爬墙壁、在表面间跳跃，并找到通往下一关神秘传送门的完美路径。",
      "instructions": "海绵挑战采用简单而吸引人的控制方式。轻触屏幕使海绵跳跃。利用墙壁和平台有策略地改变空中方向，让你能有效通过每个关卡中的障碍和陷阱。",
      "genres": [
        "敏捷性",
        "休闲"
      ],
      "tags": [
        "方块",
        "钻石",
        "物理",
        "平台游戏",
        "奔跑"
      ]
    },
    "zh-TW": {
      "title": "海綿挑戰",
      "description": "在Sponge Challenge中，你將指揮一塊 bounce 的黃色海綿通過迷人的 2D 遊戲平台解謎冒險。你的任務是引導這塊靈活的海綿收集寶貴的紫色鑽石，同時在充滿障礙和狡猾陷阱的關卡中穿行。每個階段都會出現一個獨特的謎題，需要你運用海綿的粘性能力攀爬牆壁、跳躍於不同表面，並找到通往下一關神奇入口的完美路徑。",
      "instructions": "海绵挑戰採用簡單而吸引人的操作。點擊螢幕讓你的海绵跳躍。利用牆壁和平台策略性地改變方向，讓你有效通過每關的障礙和陷阱。",
      "genres": [
        "敏捷度",
        "休闲"
      ],
      "tags": [
        "立方體",
        "鑽石",
        "物理學",
        "平台遊戲",
        "奔跑"
      ]
    },
    "zh-HK": {
      "title": "膠囊挑戰",
      "description": "在「Sponge Challenge」中，你將指揮一塊彈跳的黃色海綿穿越迷人的2D解謎平台冒險。你的任務是引導這塊靈活的海綿收集珍貴的紫色鑽石，並在充滿障礙和狡猾陷阱的關卡中穿梭。每個關卡都會呈現一個獨特的謎題，需要你運用海綿的粘性能力攀爬牆壁、跳躍於各種表面，並找到通往下一關魔法通道的完美路徑。",
      "instructions": "海綿挑戰採用簡單而吸引人的操控方式。輕觸螢幕讓你的海綿跳躍。利用牆壁和平台策略性地改變空中方向，讓你能有效通過每個關卡的障礙和陷阱。",
      "genres": [
        "敏捷度",
        "輕鬆"
      ],
      "tags": [
        "立方體",
        "鑽石",
        "物理學",
        "平台遊戲",
        "奔跑"
      ]
    },
    "ja": {
      "title": "スパンジャーチャレンジ",
      "description": "サンゴチャレンジで、黄色く弾力のあるサンゴを操作し、魅力的な2Dパズルプラットフォーム冒険に挑戦します。あなたのミッションは、柔軟なサンゴを紫の宝石を収集しながら、障害とトリックでいっぱいのレベルを進むことで、壁を登り、表面間をジャンプし、次のレベルに続く魔法のポータルにたどり着く最適な道を見つけることです。それぞれのステージはユニークなパズルを提供し、サンゴの粘着性を利用して壁を登り、表面間をジャンプし、次のレベルに続く魔法のポータルにたどり着く最適な道を見つけることを要求します。",
      "instructions": "スパンジャー・チャレンジはシンプルで楽しいコントロールを採用しています。スクリーンをタップしてスパンジャーをジャンプさせましょう。壁やプラットフォームを戦略的に利用して空中で方向を変更し、各レベルの障害や罠を効果的に乗り越えましょう。",
      "genres": [
        "アグレシビティ",
        "カジュアル"
      ],
      "tags": [
        "キューブ",
        "ダイヤモンド",
        "物理",
        "プラットフォーム",
        "走る"
      ]
    },
    "ko": {
      "title": "스폰지 챌린지",
      "description": "스폰지 챌린지에서는 탄력 있는 노란 습식을 통해 매력적인 2D 패들 플랫폼 어드벤처를 이끌어야 합니다. 당신의 임무는 유연한 습식을 이끌어 귀중한 파란 보석을 모으고, 장애물과 복잡한 함정이 가득한 레벨을 통해 이동하는 것입니다. 각 단계는 습식의 점착력을 활용하여 벽을 오르고 표면 간을 건너며 마법의 포털로 이어지는 완벽한 경로를 발견해야 하는 독특한 퍼즐을 제공합니다.",
      "instructions": "스폱지엘렌스는 간단하지만 재미있는 컨트롤을 제공합니다. 화면을 탭하여 습식을 뛰게 만들어주세요. 벽과 플랫폼을 전략적으로 활용하여 중간에 방향을 바꿔서 각 레벨의 장애물과 응시를 효과적으로 통과할 수 있습니다.",
      "genres": [
        "민첩성",
        "캐주얼"
      ],
      "tags": [
        "큐브",
        "다이아몬드",
        "물리학",
        "플랫폼게임",
        "달리기"
      ]
    },
    "fr": {
      "title": "Défi Éponge",
      "description": "Dans le Défi Éponge, vous commandez une éponge jaune élastique dans une aventure de plates-formes en 2D captivante. Votre mission est d'orienter l'éponge flexible pour ramasser des diamants purpurés tout en manœuvrant à travers des niveaux remplis d'obstacles et de pièges vicieux. Chaque étape présente un puzzle unique qui nécessite d'utiliser les capacités collantes de l'éponge pour grimper aux murs, sauter entre les surfaces et découvrir le chemin parfait vers le portail magique qui mène aux niveaux suivants.",
      "instructions": "Le défi Éponge utilise des contrôles simples mais captivants. Tappez sur l'écran pour faire sauter votre éponge. Utilisez les murs et les plateformes stratégiquement pour changer de direction en vol, ce qui vous permet de naviguer efficacement à travers les obstacles et les pièges de chaque niveau.",
      "genres": [
        "Agilité",
        "Occasionnel"
      ],
      "tags": [
        "cube",
        "diamants",
        "physique",
        "plate-forme",
        "course"
      ]
    }
  }
};
